import { generateApiPath } from "@routes/generatePath.ts";
import type { IExtractApiParams } from "@routes/types.ts";

const pathBase = `/illnesses/`;
const pathById = `${pathBase}:illnessesId/`;

type IPathByIdParams = IExtractApiParams<typeof pathById>;

export const illnesses = {
  getAll: () => generateApiPath(pathBase),
  post: () => generateApiPath(pathBase),
  put: (params: IPathByIdParams) => generateApiPath(pathById, params),
  delete: (params: IPathByIdParams) => generateApiPath(pathById, params),
};
